"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Upload from foundation/Upload
 * @trackcomponent
 */
export const Export = createSVGIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M10.9091 9.55402V11.491C10.9091 11.6433 10.785 11.7668 10.6362 11.7668L1.36375 11.7668C1.21306 11.7668 1.09091 11.6415 1.09091 11.491V9.55402C1.09091 9.2485 0.846702 9.00083 0.545455 9.00083C0.244208 9.00083 0 9.2485 0 9.55402V12.0447C0 12.5012 0.369115 12.8732 0.820575 12.8732L11.1794 12.8732C11.6316 12.8732 12 12.5039 12 12.0447V9.55402C12 9.2485 11.7558 9.00083 11.4545 9.00083C11.1533 9.00083 10.9091 9.2485 10.9091 9.55402ZM9.64886 3.46937L6.46845 0.202605C6.20429 -0.0687332 5.77609 -0.0676413 5.51066 0.20647L2.35112 3.46937C1.83778 3.99107 2.60751 4.77335 3.12085 4.25165L5.26456 2.07113C5.37008 1.9638 5.45563 2.00148 5.45563 2.15369V8.16968C5.45563 8.47595 5.69725 8.72423 5.99999 8.72423C6.30064 8.72423 6.54436 8.47648 6.54436 8.16968V2.15369C6.54436 2.00076 6.63022 1.96412 6.73542 2.07113L8.87913 4.25165C9.3922 4.77335 10.1622 3.99107 9.64886 3.46937Z"
  />,
  "Export",
  { viewBox: "0 0 12 13", titleAccess: "Export", fill: "none" }
);
